module.exports = __webpack_public_path__ + "img/Insta-Bsp-01.2f737191.jpg";